import React from 'react';

import styled from 'styled-components';

import { TextLink } from '@techstyle/react-components';
import { FormattedMessage } from '@techstyle/react-intl';

const DiscloseMessage = styled.p`
  ${({ theme }) => theme.subHeader.variants.subHeading4.textStyles}
  font-weight: 400;
`;

const ForgetToSkipText = styled.span`
  font-weight: bold;
  color: inherit;
  && {
    text-transform: uppercase;
  }
`;

const LearnMoreText = styled(TextLink)`
  color: inherit;
  && {
    text-decoration: underline;
    text-transform: uppercase;
  }
`;

const ColorWrapper = styled.span`
  font-weight: bold;
  color: ${({ color, theme }) => theme.colors[color]};
`;

const MembershipFooterDisclaimer = ({
  onLearnMoreClick,
  membershipOptInVariant,
}) => {
  const color = membershipOptInVariant === 'modal' ? 'white' : 'memberOffers';

  return (
    <>
      <DiscloseMessage>
        <FormattedMessage
          defaultMessage="{membership} allows you to shop or “Skip the Month” by the 5th of each month or your payment method will be charged $59.95 on the 6th until you cancel. Cancel anytime by calling 1-855-SAVAGE-X."
          id="global_checkout.shop_emp_tip_p3"
          values={{
            membership: (
              <ColorWrapper color={color}>
                <FormattedMessage
                  id="global_checkout.membership_modal_flexible_rewards_membership"
                  defaultMessage="Flexible Rewards Membership"
                />
              </ColorWrapper>
            ),
          }}
        />
      </DiscloseMessage>
      <br />
      <DiscloseMessage>
        <FormattedMessage
          id="global_checkout.shop_emp_tip_p4"
          defaultMessage="{skip} Your payment method will be charged $59.95, which includes 1 Member Credit that can be redeemed on a future purchase."
          values={{
            skip: (
              <ColorWrapper color={color}>
                <ForgetToSkipText>
                  <FormattedMessage
                    id="global_checkout.emp_forgot_skip"
                    defaultMessage="Forget to skip the month? No worries!"
                  />
                </ForgetToSkipText>
              </ColorWrapper>
            ),
          }}
        />{' '}
        <ColorWrapper color={color}>
          <LearnMoreText onClick={onLearnMoreClick}>
            <FormattedMessage
              defaultMessage="Learn more"
              id="global_checkout.membership_learn_more_link"
            />
          </LearnMoreText>
        </ColorWrapper>
      </DiscloseMessage>
    </>
  );
};

export default MembershipFooterDisclaimer;
